import FolderIcon from "@mui/icons-material/Folder";
import DescriptionIcon from "@mui/icons-material/Description";
import ImageIcon from "@mui/icons-material/Image";
import CodeIcon from "@mui/icons-material/Code";
import TableChartIcon from "@mui/icons-material/TableChart";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { SvgIconProps } from "@mui/material/SvgIcon";

const EXT_ICON_MAP: Record<string, React.ComponentType<SvgIconProps>> = {
  // Documents
  pdf: PictureAsPdfIcon,
  doc: DescriptionIcon,
  docx: DescriptionIcon,
  txt: DescriptionIcon,
  md: DescriptionIcon,
  rtf: DescriptionIcon,
  odt: DescriptionIcon,
  // Spreadsheets
  csv: TableChartIcon,
  xls: TableChartIcon,
  xlsx: TableChartIcon,
  tsv: TableChartIcon,
  // Images
  png: ImageIcon,
  jpg: ImageIcon,
  jpeg: ImageIcon,
  gif: ImageIcon,
  svg: ImageIcon,
  webp: ImageIcon,
  bmp: ImageIcon,
  // Code
  py: CodeIcon,
  js: CodeIcon,
  ts: CodeIcon,
  tsx: CodeIcon,
  jsx: CodeIcon,
  json: CodeIcon,
  html: CodeIcon,
  css: CodeIcon,
  sql: CodeIcon,
  sh: CodeIcon,
  yaml: CodeIcon,
  yml: CodeIcon,
  xml: CodeIcon,
};

export function getFileIcon(
  filename: string,
  isDir: boolean,
): React.ComponentType<SvgIconProps> {
  if (isDir) return FolderIcon;
  const ext = filename.split(".").pop()?.toLowerCase() ?? "";
  return EXT_ICON_MAP[ext] ?? InsertDriveFileIcon;
}

// Re-export of the global helper. The previous local implementation
// returned "" for null/0 (used to render blank size cells for directories);
// callers that need that should guard at the callsite before invoking.
export { formatFileSize } from "src/helpers/formatFileSize";
